const updateArray = (oldArray = [], newArray = []) =>
  oldArray.map(oldComponent => newArray.find(newComponent => newComponent.id === oldComponent.id) || oldComponent);

export default updateArray;
